import { render } from "./np-skeleton.vue?vue&type=template&id=4ade1d8e&scoped=true"
import script from "./np-skeleton.vue?vue&type=script&lang=js"
export * from "./np-skeleton.vue?vue&type=script&lang=js"

import "./np-skeleton.vue?vue&type=style&index=0&id=4ade1d8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ade1d8e"]])

export default __exports__